import React, { Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function ComboBoxAutocomplete(props) {
  const size = props.multiple ? 'medium' : 'small';
  const formatSelectedItem = (selectedItem) => {
    let selectedOption = '';
    if (props.multiple || props.wholeObject) {
      selectedOption = selectedItem;
    } else if (props.dataValuesStrings) {
      selectedOption = selectedItem.value;
    } else {
      selectedOption = selectedItem.id;
    }
    return selectedOption;
  };

  const selectedOptionHandler = (option, value) => {
    if (option.id && value.id) {
      return option.id === value.id;
    } else if (value.value) {
      return option.value === value.value;
    } else {
      return option === value || null;
    }
  };

  return (
    <Fragment>
      <Autocomplete
        id={props.id}
        options={props.data.filter((d) => props.text(d) != null)}
        getOptionLabel={(a) => props.text(a) || ''}
        value={props.updateValue ? props.updateValue : null}
        style={props.style || { width: '100%', color: 'white !important' }}
        disabled={props.disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.placeholder || ''}
            variant={props.variant || 'outlined'}
            required={props.required}
            InputLabelProps={{
              style: {
                color: 'rgb(94, 94, 94)',
              },
              shrink: true,
            }}
          />
        )}
        blurOnSelect="touch"
        size={size}
        onChange={(event, selectedItem) => {
          const selectedOption = selectedItem
            ? formatSelectedItem(selectedItem)
            : '';
          props.changeValue(selectedOption);
        }}
        multiple={props.multiple}
        getOptionSelected={selectedOptionHandler}
        disableClearable={props.disableClearable || false}
      />
      {props.error && (
        <b>
          <div style={{ color: 'red' }}>{props.error}</div>
        </b>
      )}
    </Fragment>
  );
}
